import { getAttributeColor } from "@/pages/DetailedPlayer/sections/Attributes/AttributesSection";
import clsx from "clsx";

import {
  fullIncreaseIcon,
  noIncreaseIcon,
  partialIncreaseIcon,
} from "../../../../../designSystemIcons";

type Cap = "no-increase" | "partial-increase";
export type Caps = {
  skillMoves?: Cap;
  weakfoot?: Cap;
  PAC?: Cap;
  SHO?: Cap;
  PAS?: Cap;
  DRI?: Cap;
  DEF?: Cap;
  PHY?: Cap;
};

export const Attributes = ({
  attributes,
  attributesUpgrades,
  isGk,
  caps,
}: {
  attributes: number[];
  attributesUpgrades?: number[];
  isGk?: boolean;
  caps?: Caps;
}) => {
  const hasEvoUpgrades = attributesUpgrades?.some((attr) => attr > 0);
  return (
    <div className="w-full px-4 md-sm:px-2 pb-1 md-sm:pt-1 text-[12px] grid grid-rows-2 grid-cols-3 md-xs:grid-rows-1 md-xs:grid-cols-6 touch-device:grid-rows-2 touch-device:grid-cols-3 large:grid-rows-1 large:grid-cols-6">
      <Attribute
        label={isGk ? "DIV" : "PAC"}
        value={attributes[0]}
        upgrade={!!attributesUpgrades?.[0]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.PAC === "partial-increase"}
        upgradeAlreadyCapped={caps?.PAC === "no-increase"}
      />
      <Attribute
        label={isGk ? "HAN" : "SHO"}
        value={attributes[1]}
        upgrade={!!attributesUpgrades?.[1]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.SHO === "partial-increase"}
        upgradeAlreadyCapped={caps?.SHO === "no-increase"}
      />
      <Attribute
        label={isGk ? "KIC" : "PAS"}
        value={attributes[2]}
        upgrade={!!attributesUpgrades?.[2]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.PAS === "partial-increase"}
        upgradeAlreadyCapped={caps?.PAS === "no-increase"}
      />
      <Attribute
        label={isGk ? "REF" : "DRI"}
        value={attributes[3]}
        upgrade={!!attributesUpgrades?.[3]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.DRI === "partial-increase"}
        upgradeAlreadyCapped={caps?.DRI === "no-increase"}
      />
      <Attribute
        label={isGk ? "SPD" : "DEF"}
        value={attributes[4]}
        upgrade={!!attributesUpgrades?.[4]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.DEF === "partial-increase"}
        upgradeAlreadyCapped={caps?.DEF === "no-increase"}
      />
      <Attribute
        label={isGk ? "POS" : "PHY"}
        value={attributes[5]}
        upgrade={!!attributesUpgrades?.[5]}
        evo={hasEvoUpgrades}
        upgradeCapped={caps?.PHY === "partial-increase"}
        upgradeAlreadyCapped={caps?.PHY === "no-increase"}
      />
    </div>
  );
};

type AttributeProps = {
  label: string;
  value: number;
  evo?: boolean;
  upgrade?: boolean;
  upgradeCapped?: boolean;
  upgradeAlreadyCapped?: boolean;
};
const Attribute = ({
  label,
  value,
  upgrade,
  evo,
  upgradeCapped,
  upgradeAlreadyCapped,
}: AttributeProps) => {
  const color = getAttributeColor(value);
  return (
    <div className="flex flex-col">
      <div className="flex flex-col my-auto">
        {evo && (
          <div className="w-3 h-3 mx-auto text-ea-dark-green touch-device:hidden large:flex">
            {upgradeAlreadyCapped
              ? noIncreaseIcon
              : upgradeCapped
                ? partialIncreaseIcon
                : upgrade && fullIncreaseIcon}
          </div>
        )}
        <div
          className={clsx(
            "mx-auto text-tiny desktop:text-xs",
            upgrade ? "text-ea-dark-green" : "text-gray-600 ",
          )}
        >
          {label}
        </div>
        <div className="mx-auto font-semibold leading-none large-desktop:text-lg mobile:text-sm text-tiny md-lg:text-xs">
          {value}
        </div>
        <div
          className={`h-[1px] md-sm:h-[1.7px] w-[14px] md-lg:w-[17px] desktop:w-[25px] desktop:h-[2.5px] mx-auto ${color} rounded-sm`}
        />
      </div>
    </div>
  );
};
